export default function HeroCard6() {
  return (
    <>
      <section className="lexi-hero">

        <div className="lexi-container">

          {/* LEFT SECTION */}
          <div className="lexi-left fadeInUp">
            <p className="lexi-tagline">
              <span className="glow-dot"></span>
              Powering Every Step of Your Ads in One Seamless Flow.
            </p>

            <h1 className="lexi-title">
              Always-On <br />
              <span className="grad-text">Monitoring</span>
            </h1>

            <button className="lexi-btn btn-anim">Get Started</button>
          </div>

          {/* RIGHT SECTION */}
          <div className="lexi-right fadeIn">

            {/* Floating stacked cards */}
            <div className="lexi-cards">
<div className="zen-c6img-wrapper">
        
              <div className="floatCard1" >
               {/* Reviews Badge */}
            <div className="hp-reviews slideInRight" >
              <p>Our Reviews</p>
              <div className="hp-avatars">
                <img src="https://i.pravatar.cc/80?img=11" />
                <img src="https://i.pravatar.cc/80?img=22" />
                <img src="https://i.pravatar.cc/80?img=33" />
                <img src="https://i.pravatar.cc/80?img=44" />
                <span>+123k</span>
              </div>
            </div>

             </div>
     
              <div className="floatCard2"style={{left:"50px",top:"180px",height:"50px"}}>
               {/* Price Card */}
            <div className="hp-price fadeInUp">
              <h3>$179 <span className="hp-badge">Save 30% Today</span></h3>
              <p>Original Price $189</p>
            </div>  </div>

              <div className="floatCard3">
               {/* Price Card */}
            <div className="hp-price fadeInUp" style={{left:"50px",top:"140px",height:"50px"}}>
              <h3>$179 <span className="hp-badge">Save 30% Today</span></h3>
              <p>Original Price $189</p>
            </div>  </div>

              <div className="floatCard4">
               {/* Price Card */}
            <div className="hp-price fadeInUp"style={{left:"30px",top:"50px",height:"50px"}}>
              <h3>$179 <span className="hp-badge">Save 30% Today</span></h3>
              <p>Original Price $189</p>
            </div>  </div></div>

            </div>

            {/* Side scroll dots */}
            <div className="vertical-dots">
              <span className="dot active"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>

          </div>

        </div>
      </section>

      <style>{`
       
.zen-c6img-wrapper {
  position: relative;margin-top:50px;
  width: 280px;
  height: 350px;
  border-radius: 150px;
  border: 14px dashed #fff;
}
/* ====================== BASE SECTION ====================== */
.lexi-hero {
  width: 100%;
  padding: 80px 0 120px;
  background: #ffffff;
  color: #1d1d1f;
  font-family: Inter, sans-serif;
  overflow:hidden;
}

.lexi-container {
  width: 90%;
  max-width: 1300px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  gap: 60px;
  align-items: center;
}

/* ====================== LEFT SECTION ====================== */
.lexi-left {
  flex: 1;
}

.lexi-tagline {
  font-size: 15px;
  color: #777;
  margin-bottom: 22px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.glow-dot {
  width: 10px;
  height: 10px;
  background: radial-gradient(circle, #8260ff, #4b00ff);
  border-radius: 50%;
  box-shadow: 0 0 10px #7a54ff, 0 0 20px #7a54ff;
  display:inline-block;
}

.lexi-title {
  font-size: 62px;
  font-weight: 800;
  line-height: 1.05;
}

.grad-text {
  background: linear-gradient(90deg, #925bff, #6f4bff, #9a7fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lexi-btn {
  margin-top: 30px;
  background: linear-gradient(90deg, #925bff, #6f4bff);
  color: white;
  padding: 14px 36px;
  border-radius: 12px;
  border: none;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
}

/* Button hover */
.btn-anim {
  transition: transform .25s ease, box-shadow .25s ease;
}
.btn-anim:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(120,80,255,0.28);
}

/* ====================== RIGHT SECTION ====================== */
.lexi-right {
  flex: 1;
  display: flex;
  justify-content: center;
  position: relative;
}

.lexi-cards {
  position: relative;
  width: 420px;
  height: 380px;
}

/* Card Base */
.card {
  position: absolute;
  width: 230px;
  background: white;
  padding: 0;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.12);
  overflow: hidden;
  border: 1px solid #f0f0f0;
}
.card img { width: 100%; display: block; }

/* Card Positions (stacked like Lexi.ai) */
.card1 { left: 20px; top: 60px;  z-index: 4; }
.card2 { left: 110px; top: 10px; z-index: 3; }
.card3 { left: 200px; top: 90px; z-index: 2; }
.card4 { left: 140px; top: 170px; z-index: 1; }

/* Floating Animations */
.floatCard1 { animation: float1 4s ease-in-out infinite; }
.floatCard2 { animation: float2 4.6s ease-in-out infinite; }
.floatCard3 { animation: float3 5s ease-in-out infinite; }
.floatCard4 { animation: float4 5.4s ease-in-out infinite; }

@keyframes float1 { 0%{transform:translateY(0)}50%{transform:translateY(142px)}100%{transform:translateY(0)} }
@keyframes float2 { 0%{transform:translateY(0)}50%{transform:translateX(118px)}100%{transform:translateX(0)} }
@keyframes float3 { 0%{transform:translateY(0)}50%{transform:translateY(50px)}100%{transform:translateY(0)} }
@keyframes float4 { 0%{transform:translateY(0)}50%{transform:translateX(245px)}100%{transform:translateX(0)} }

/* ====================== RIGHT DOTS ====================== */
.vertical-dots {
  position: absolute;
  right: -40px;
  top: 50%;
  transform: translateY(-50%);
  display:flex;
  flex-direction: column;
  gap: 14px;
}

.dot {
  width: 12px;
  height: 12px;
  background: #d8d6ff;
  border-radius: 50%;
  opacity: .7;
}
.dot.active {
  background: #9485ff;
  box-shadow: 0 0 10px #9077ff;
}

/* ====================== ANIMATIONS ====================== */

.fadeInUp {
  opacity: 0;
  animation: fadeUp 1s ease forwards;
}
@keyframes fadeUp {
  0% {opacity:0; transform:translateY(25px)}
  100%{opacity:1; transform:translateY(0)}
}

.fadeIn {
  opacity: 0;
  animation: fadeInAnim 1s ease forwards .3s;
}
@keyframes fadeInAnim {
  0% {opacity:0; transform: scale(.96);}
  100%{opacity:1; transform: scale(1);}
}

/* ====================== RESPONSIVE ====================== */
@media (max-width: 960px) {
  .lexi-container {
    flex-direction: column;
    text-align: center;
  }
  .lexi-right {
    margin-top: 50px;
  }
  .vertical-dots {
    right: 0;
    top: auto;
    bottom: -30px;
    transform:none;
    flex-direction: row;
  }
}
      `}</style>
    </>
  );
}
